import { render, staticRenderFns } from "./RelacaoContratoFiltro.vue?vue&type=template&id=54154fd8"
import script from "./RelacaoContratoFiltro.vue?vue&type=script&lang=js"
export * from "./RelacaoContratoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports